// src/app/hooks/access_door/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useGetAccessDoorParamsQuery,
  useLazyGetAccessDoorQuery,
} from '../../services';
import { setAccessDoor, setAccessDoorParams } from '../../slices';
import { useGetAccessoryPosition } from '../ahu';

export const useGetAccessDoorMainData = (id: number) => {
  const { isLoading: accessDoorLoading } = useGetAccessDoor(id);
  const { isLoading } = useGetAccessDoorParams();
  const {
    position,
    isLoading: positionLoading,
    getPosition,
  } = useGetAccessoryPosition(id);
  return {
    isLoading: isLoading || accessDoorLoading || positionLoading,
    getPosition,
    position,
  };
};

export const useGetAccessDoor = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getAccessDoor, { data: access_door, isLoading }] =
    useLazyGetAccessDoorQuery();

  useEffect(() => {
    if (fetch && id) {
      getAccessDoor(id);
    }
  }, [id]);

  useEffect(() => {
    if (access_door) dispatch(setAccessDoor(access_door));
  }, [access_door]);

  return {
    access_door,
    isLoading,
    getAccessDoor,
  };
};

export const useGetAccessDoorParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetAccessDoorParamsQuery();

  useEffect(() => {
    if (params) {
      dispatch(setAccessDoorParams(params.access_door));
    }
  }, [params]);

  return { isLoading, params, get: refetch };
};
